import React, { createRef } from 'react';
import styled, { css } from 'styled-components';

const toggledOn = (props: any) => {
  return css`
    background: ${(props) => props.theme.colors.switchOnBg};
    text-align: left;
    padding-left: 0.3125rem;

    :before {
      border-color: ${(props) => props.theme.colors.switchOnBg};
      right: 0px;
      background: ${(props) => props.theme.colors.switchOnCircle};
      box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 6px, rgba(0, 0, 0, 0.2) 0px 1px 4px;
    }
  `;
};

const toggledOff = (props: any) => {
  return css`
    background: ${(props) => props.theme.colors.appPrimary};
    text-align: right;
    padding-left: 0.3125rem;

    :before {
      border-color: ${(props) => props.theme.colors.appPrimaryLight};
      right: 1.125rem;
      background: ${(props) => props.theme.colors.switchOffCircle};
      box-shadow: rgba(0, 0, 0, 0.117647) 0px 1px 6px, rgba(0, 0, 0, 0.117647) 0px 1px 4px;
    }
  `;
};

const Outer: any = styled.div`
  display: inline-block;
  position: relative;
  width: 2.25rem;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  padding-top: 5px;
`;

const Inner: any = styled.div`
  ${(props: any) => (props.value ? toggledOn(props) : toggledOff(props))}
  display: block;
  overflow: hidden;
  cursor: pointer;
  height: 0.625rem;
  padding: 0;
  line-height: 0.625rem;
  border: 0rem solid #ffffff;
  border-radius: 1.25rem;
  background-color: ${(props) => props.theme.colors.appPrimary};
  width: 100%;
  font-size: 0.75rem;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  outline: none;

  :before {
    content: '';
    display: block;
    width: 1.125rem;
    position: absolute;
    top: 1px;
    bottom: 0;
    border-radius: 1.125rem;
    height: 1.125rem;
    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  }

  :focus::before {
    width: 1.25rem;
    height: 1.25rem;
  }
`;

export type IToggleProps = {
  id: string;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  onChange: (value: boolean) => void;
  onFocus: (e: React.FocusEvent<HTMLInputElement>) => void;
  value: boolean;
  tabIndex?: number;
  testId?: any;
};

const Toggle = (props: IToggleProps) => {
  const handleToggleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    const value: boolean = !props.value;
    props.onChange(value);
  };

  /*
   *  Y     - Sets the switch to on
   *  N     - Sets the switch to off
   *  Space - Inverts the current value
   */
  const handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>): void => {
    let value: boolean | undefined;

    switch (event.key) {
      case 'Y':
      case 'y':
        value = true;
        break;
      case 'N':
      case 'n':
        value = false;
        break;
      case ' ':
        value = !props.value;
        break;
      default:
        break;
    }
    if (!!value) {
      props.onChange(value);
    }
  };

  const { id, onFocus, onBlur, tabIndex, testId, value } = props;
  const inner = createRef();

  return (
    <Outer>
      <Inner
        data-testid={testId}
        id={id}
        onClick={handleToggleClick}
        onKeyPress={handleKeyPress}
        onFocus={onFocus}
        onBlur={onBlur}
        ref={inner}
        value={value}
        tabIndex={tabIndex}
      >
        <span />
      </Inner>
    </Outer>
  );
};

Toggle.defaultProps = {
  id: '',
  onBlur: () => {},
  onChange: () => {},
  onFocus: () => {},
  testId: '',
  value: true,
};

export default Toggle;
